import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Alert } from 'react-bootstrap';
import { Icon } from '../components/Icon';

const NotFoundPage = (): React.ReactElement | null => {
    return (
        <Alert variant='danger' className='fs-5 m-5 d-flex justify-content-center'>
            <Icon icon={faExclamationTriangle}>Page not found</Icon>
        </Alert>
    );
};

export default NotFoundPage;
